import { render, staticRenderFns } from "./Landcover.vue?vue&type=template&id=655657d0&scoped=true"
import script from "./Landcover.vue?vue&type=script&lang=js"
export * from "./Landcover.vue?vue&type=script&lang=js"
import style0 from "./Landcover.vue?vue&type=style&index=0&id=655657d0&prod&lang=css"
import style1 from "./Landcover.vue?vue&type=style&index=1&id=655657d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655657d0",
  null
  
)

export default component.exports